<template>
  <div class="page-wrapper">
    <div class="page-title">
      <CIcon name="cil-file" /> View Case
      <span class="page-title-badge" v-if="report">{{ report.caseNumber }}</span>
    </div>
    <CRow v-if="report == null">
        <CCol md="12" class="text-center" v-if="reportError == ''">
            <strong>Loading...Please wait!</strong>
            <CProgress
                :value="100"
                color="primary"
                striped
                animated
                class="mb-2"
            />
        </CCol>
        <CCol md="12" class="text-center" v-else>
            <strong><CIcon name="cil-ban"/> {{reportError}}</strong>
        </CCol>
    </CRow>     
    <CRow v-else>
        <CCol md="12">
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol sm="6">
                            <h4 id="traffic" class="card-title mb-0">Case Identity</h4>
                        </CCol>
                    </CRow>                    
                </CCardHeader>
                <CCardBody>     
                    <CRow>
                        <CCol sm="6">
                            <CInput
                                label="Case Number"
                                type="text"
                                :disabled="true"
                                :value="report.caseNumber"
                            />
                        </CCol>
                        <CCol sm="6">
                            <CInput
                                label="Date Added"
                                type="text"
                                :disabled="true"
                                :value="new Date(report.dateAdded).toDateString()"
                            />
                        </CCol>
                    </CRow>   

                    <CRow>
                        <CCol sm="3">
                            <CInput
                                label="Class"
                                type="text"
                                :disabled="true"
                                :value="report.animalData.class"
                            />
                        </CCol>
                        <CCol sm="9">
                            <CInput
                                label="Group"
                                type="text"
                                :disabled="true"
                                :value="report.animalData.groupName"
                            />
                        </CCol>
                    </CRow>  

                    <CRow>
                        <CCol sm="6">
                            <CInput
                                label="Identity Name"
                                type="text"
                                :disabled="true"
                                :value="report.animalData.identityName"
                            />
                        </CCol>
                        <CCol sm="6">
                            <CInput
                                label="Category Name"
                                type="text"
                                :disabled="true"
                                :value="report.animalData.categoryName"
                            />
                        </CCol>
                    </CRow>                                                  
                </CCardBody>
            </CCard>
        </CCol>

        <CCol md="12">
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol sm="6">
                            <h4 id="traffic" class="card-title mb-0">Rescue and Admission Details</h4>
                        </CCol>
                    </CRow>                    
                </CCardHeader>
                <CCardBody>     
                    <CRow>
                        <CCol sm="6">
                            <CInput
                                label="Rescue Type"
                                type="text"
                                :disabled="true"
                                :value="report.rescueType"
                            />
                        </CCol>
                        <CCol sm="6">
                            <CInput
                                label="Date Added"
                                type="text"
                                :disabled="true"
                                :value="new Date(report.dateOfRescue).toDateString()"
                            />
                        </CCol>
                    </CRow>   

                    <CRow>
                        <CCol sm="12">
                            <CInput
                                label="Place of Rescue"
                                type="text"
                                :disabled="true"
                                :value="report.placeOfRescue"
                            />
                        </CCol>
                    </CRow>     
                    
                    <CRow>
                        <CCol sm="6">
                            <CInput
                                label="GPS Lattitude (Eg: 27.098499)"
                                type="text"
                                :disabled="true"
                                :value="report.gpsLatitudeRescue"
                            />
                        </CCol>
                        <CCol sm="6">
                            <CInput
                                label="GPS Longitude (Eg: 76.098499)"
                                type="text"
                                :disabled="true"
                                :value="report.gpsLongditudeRescue"
                            />
                        </CCol>
                    </CRow> 

                    <CRow>
                        <CCol sm="12">
                            <CInput
                                label="Cause of Displacement"
                                type="text"
                                :disabled="true"
                                :value="report.displacement"
                            />
                        </CCol>
                    </CRow>  

                    <CRow>
                        <CCol sm="6">
                            <CInput
                                label="Zone of origin"
                                type="text"
                                :disabled="true"
                                :value="report.zoneName"
                            />
                        </CCol>
                        <CCol sm="6">
                            <CInput
                                label="Date of Admission"
                                type="text"
                                :disabled="true"
                                :value="new Date(report.dateOfAdmission).toDateString()"
                            />
                        </CCol>
                    </CRow>   

                    <CRow>
                        <CCol sm="12">
                            <CInput
                                label="Case Type"
                                type="text"
                                :disabled="true"
                                :value="report.rescueMode"
                            />
                        </CCol>
                    </CRow>                                                                 
                </CCardBody>
            </CCard>
        </CCol>


        <CCol md="12">
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol sm="6">
                            <h4 id="traffic" class="card-title mb-0">Animal Details</h4>
                        </CCol>
                    </CRow>                    
                </CCardHeader>
                <CCardBody>     
                    <CRow>
                        <CCol sm="6">
                            <CInput
                                label="Age (years)"
                                type="text"
                                :disabled="true"
                                :value="report.ageYears"
                            />
                        </CCol>
                        <CCol sm="6">
                            <CInput
                                label="Age (Months)"
                                type="text"
                                :disabled="true"
                                :value="report.ageMonths"
                            />
                        </CCol>
                    </CRow>   

                    <CRow>
                        <CCol sm="12">
                            <CInput
                                label="Place of Rescue"
                                type="text"
                                :disabled="true"
                                :value="report.placeOfRescue"
                            />
                        </CCol>
                    </CRow>     
                    
                    <CRow>
                        <CCol sm="6">
                            <CInput
                                label="Stage"
                                type="text"
                                :disabled="true"
                                :value="report.stage"
                            />
                        </CCol>
                        <CCol sm="6">
                            <CInput
                                label="Sex"
                                type="text"
                                :disabled="true"
                                :value="report.sex"
                            />
                        </CCol>
                    </CRow> 

                    <CRow>
                        <CCol sm="6">
                            <CInput
                                label="Body Weight"
                                type="text"
                                :disabled="true"
                                :value="report.weight"
                            />
                        </CCol>
                        <CCol sm="6">
                            <CInput
                                label="Length"
                                type="text"
                                :disabled="true"
                                :value="report.length"
                            />
                        </CCol>
                    </CRow>  

                                                                                   
                </CCardBody>
            </CCard>
        </CCol>


        <CCol md="12">
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol sm="6">
                            <h4 id="traffic" class="card-title mb-0">Outcome</h4>
                        </CCol>
                    </CRow>                    
                </CCardHeader>
                <CCardBody>     

                    <CRow>
                        <CCol sm="12">
                            <CInput
                                label="Final Disposition"
                                type="text"
                                :disabled="true"
                                :value="report.finalDisposition"
                            />
                        </CCol>
                    </CRow>     
                    
                    <CRow>
                        <CCol sm="6">
                            <CInput
                                v-if="report.dateOfDeath"
                                label="Date of Death"
                                type="text"
                                :disabled="true"
                                :value="new Date(report.dateOfDeath).toDateString()"
                            />
                            <CInput
                                v-else
                                label="Date of Death"
                                type="text"
                                :disabled="true"
                                value="-"
                            />
                        </CCol>
                        <CCol sm="6">
                            <CInput
                                label="Clinical signs before death"
                                type="text"
                                :disabled="true"
                                :value="report.clinicalSigns"
                            />
                        </CCol>
                    </CRow> 

                    <CRow>
                        <CCol sm="12">
                            <CInput
                                label="Remarks"
                                type="text"
                                :disabled="true"
                                :value="report.remarks"
                            />
                        </CCol>
                    </CRow>  

                                                                                   
                </CCardBody>
            </CCard>
        </CCol>

        <!-- <CCol md="12">
            <CCard>
                <CCardBody>
                    <div style="height: 500px; width: auto; margin : 10px" >
                        <l-map
                            v-if="!loading"
                            :zoom="zoom"
                            :center="center"
                            :options="mapOptions"
                        >
                            <l-tile-layer
                                :url="url"
                                :attribution="attribution"
                            />
                            

                            <l-marker :lat-lng="getLatLng(report.gpsLatitudeRescue,report.gpsLongditudeRescue)">
                                <l-popup>
                                <div>
                                    <b>Sighting Point</b>
                                </div>
                                </l-popup>
                            </l-marker>
                            
                            <l-control
                                :position="'bottomleft'"
                                class="custom-control-watermark"
                            >
                                Map generated by Strofes Technologies
                            </l-control>
                        </l-map>

                        <grid-loader :loading="loading" color="#2E7D32" ></grid-loader>
                    </div>
                </CCardBody>
            </CCard>          
        </CCol> -->
    </CRow>     
  </div>
</template>

<script>
import axios from 'axios';
import store from '../store';
import { latLng, latLngBounds } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LControl, LPolyline } from "vue2-leaflet";
import { Icon } from 'leaflet';
import GridLoader from 'vue-spinner/src/GridLoader.vue'
export default {
    name: 'SingleReport',
    props : ['id'],
    components: {
            LMap,
            LTileLayer,
            LMarker,
            LPopup,
            LTooltip,
            LControl,
            Icon,
            GridLoader,
            LPolyline
    },
    data () {
        return {
            baseURL : store.state.baseURL,
            time : '',
            show: true,
            horizontal: { label:'col-3', input:'col-9' },
            formCollapsed: true,
            report : null,
            reportError : '',
            zoom: 13,
            bounds: null,            
            center: latLng(12.9716, 77.5946),
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            withPopup: latLng(47.41322, -1.219482),
            withTooltip: latLng(47.41422, -1.250482),
            currentZoom: 11.5,
            currentCenter: latLng(47.41322, -1.219482),
            largeModal : false,
            noimage : '/img/noimage.png',
            newStatus : '',
            mapOptions: {
                zoomSnap: 0.5
            },
            showMap: true,
            redIcon : null,
            greenIcon : null,
            loading : true,


            
            
        }
    },
    mounted(){
        delete Icon.Default.prototype._getIconUrl;
        Icon.Default.mergeOptions({
            iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
            iconUrl: require('leaflet/dist/images/marker-icon.png'),
            shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        });
        this.redIcon = L.icon({
            iconUrl: '/img/red_map_icon.png',
        });
        this.greenIcon = L.icon({
            iconUrl: '/img/green_map_icon.png',
        });
        this.getreport();
    },
    methods: {
        highlightRecord(id){
            alert(id);

        },
        getLatLng(lat, lng){
            return latLng(lat, lng);
        },
        zoomUpdate(zoom) {
            this.currentZoom = zoom;
        },
        centerUpdate(center) {
            this.currentCenter = center;
        },
        today(){
            var date = new Date;;
            date = date.toISOString();
            return date.substring(0,10);
        },
        getreport(){
            axios({
                url : this.baseURL + "records/get-one/"+this.id,
                headers : {
                    authorization : store.state.token
                },
                method : "GET"
            })
            .then(res => {
                if(res.data.status)
                {
                    this.report = res.data.data;   
                    this.report.image = this.report.image === undefined ? '/img/noimage.png' : this.baseURL + this.report.image;  
                    // this.center = latLng(this.report.gpsLatitudeRescue, this.report.gpsLongditudeRescue)
                    this.loading = false;
                }
                else
                {
                    this.$notify({
                        group: 'notification',
                        type : 'warn',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Something went wrong!\nCouldn\'t fetch data'
                });
                console.log(err);
                this.reportError = 'Something went wrong!\nCouldn\'t fetch data';
            });
        },
        // deleteRecord(){
        //     if(confirm('Are you sure? Do you want to delete the record?')){
        //         axios({
        //             url : this.baseURL + "report/delete",
        //             headers : {
        //                 authorization : store.state.token
        //             },
        //             method : "POST",
        //             data : {
        //                 id  : this.id
        //             }
        //         })
        //         .then(res => {
        //             if(res.data.status)
        //             {
        //                 this.$notify({
        //                     group: 'notification',
        //                     type : 'success',
        //                     title: 'Important message',
        //                     text: 'Successfully deleted. Please wait you are being redirected'
        //                 });   
        //                 this.$router.push({ path: `/alerts` });
                        
        //             }
        //             else
        //             {
        //                 this.$notify({
        //                     group: 'notification',
        //                     type : 'warn',
        //                     title: 'Important message',
        //                     text: res.data.message
        //                 });
        //             }
        //         })
        //         .catch(err => {
        //             this.$notify({
        //                 group: 'notification',
        //                 type : 'error',
        //                 title: 'Important message',
        //                 text: 'Something went wrong!\nCouldn\'t fetch data'
        //             });
        //             console.log(err);
        //             this.reportError = 'Something went wrong!\nCouldn\'t delete record';
        //         });
        //     }
        // },
        
    }
}
</script>
<style scoped>
    table, th, td {
        border: 1px solid black;
    }
</style>
